import { DateParameter, type SearchValues, useAssignQueryParameter, useUpdateQueryParams } from '@pba/react-router';
import { useCallback, useMemo } from 'react';
import type { CreateReminderParams, SlotStart } from 'features/calendar';
import { CreateReminderActionParameter } from './CreateReminderActionParameter';

type P = {
  actionKey?: string;
  startDateKey?: string;
};

export const useCreateReminderParams = ({
  actionKey = 'action',
  startDateKey = 'startDate',
}: P = {}): CreateReminderParams => {
  const updateQueryParams = useUpdateQueryParams();
  const { resetValue: resetAction, value: action } = useAssignQueryParameter(actionKey, CreateReminderActionParameter);
  const { resetValue: resetStartDate, value: startDate } = useAssignQueryParameter(startDateKey, DateParameter);

  const onClose = useCallback(() => {
    const urlUpdates: SearchValues = {};
    resetAction(urlUpdates);
    resetStartDate(urlUpdates);
    updateQueryParams({ navigateOptions: { replace: true }, urlUpdates });
  }, [resetAction, resetStartDate, updateQueryParams]);

  const slotStart = useMemo((): SlotStart | undefined => {
    if (!startDate) {
      return undefined;
    }

    return {
      date: startDate,
      isTimeSpecific: true,
    };
  }, [startDate]);

  return useMemo(
    () => ({
      action,
      onClose,
      slotStart,
    }),
    [action, onClose, slotStart],
  );
};
